export const ISMOBILEPHONE_CHANGED = 'INITIALSTATE_CHANGED';
export const ISTABLET_CHANGED = 'ISTABLET_CHANGED';
export const VISIBLETABS_CHANGED = 'VISIBLETABS_CHANGED';



/** WEBPACK FOOTER **
 ** app/components/initial-app-state/state/initial-app-state-const.js
 **/